import { filter, find, cloneDeep, clone } from 'lodash';

class OrderFormController {
    constructor($state, ordersApiService, messageService) {
        this.$state = $state;
        this.ordersApiService = ordersApiService;
        this.messageService = messageService;
    }

    $onInit () {
        this.items = {};
        if (!this.order) {
            this.order = {};
        }
        if (this.order.customer && this.order.customer.marketing === 1) {
            this.order.customer.marketing = true;
        }

        this.originalTotal = clone(this.order.total);
    }

    onSave () {
        let ordercopy = cloneDeep(this.order);

        delete (this.order.basket);

        let displayitems = cloneDeep(this.order.item);
        let items = cloneDeep(this.items);
        for (let guest in items) {
            for (let item in items[guest]) {
                items[guest][item].date = items[guest][item].date.format('YYYY-MM-DD');
            }
        }

        this.order.item = items;
        return this.ordersApiService.save(this.order)
            .then(response => {
                if (this.order.deleted_at !== null) {
                    this.messageService.success(`The order <strong>${this.order.order_reference
                        }</strong> was successfully revived!`, [`app.admin.order - edit({ 'order': ${this.order.id}})`, `Order`]);
                    return;
                }
                else if (this.order.id) {
                    this.messageService.success(`The order <strong>${this.order.order_reference
                        }</strong> was successfully updated!`);
                }
                this.order = ordercopy;
                this.order.item = displayitems;
                this.messageService.push();
                this.formTab = 'summary';

                return response;
            })
            .catch((error) => {
                this.messageService.failure(`The order <strong> ${this.order.order_reference}</strong > could not be successfully created: ${error.statusText} `);
                this.messageService.push();
            });
    }

    findItems (guestid) {
        if (this.items[guestid]) return this.items[guestid];
        this.items[guestid] = filter(this.order.item, { 'guest_id': guestid }).map(item => {
            if (item.date) item.date = moment(item.date);
            return {
                'date': item.date,
                'time': item.preferred_time,
                'id': item.id,
                'name': item.name
            };
        });
        return this.items[guestid];
    }

    updateTime (item) {
        let orderItem = find(this.order.item, { 'id': item.id });
        if (orderItem) orderItem.preferred_time = item.time;
    }

    isDisputed () {
        return this.order.order_status === 'Disputed';
    }
}

OrderFormController.$inject = ['$state', 'ordersApiService', 'messageService'];

export default OrderFormController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/order/controllers/order.form.controller.js